import { render, staticRenderFns } from "./AuthenticationView.vue?vue&type=template&id=cd2966fa&scoped=true&"
import script from "./AuthenticationView.vue?vue&type=script&lang=js&"
export * from "./AuthenticationView.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationView.vue?vue&type=style&index=0&id=cd2966fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2966fa",
  null
  
)

export default component.exports